import React, { useState } from 'react'

import { ConfirmModal, Select, useModalContext } from '@fourthwall/components'

import type { VariantSelectOption } from '../../hooks/useOrderSamples/types'

type Props = {
  options: VariantSelectOption[]
  onConfirm: (variantId: string) => void
}

export const OrderSamplesVariantSelectModal = ({ options, onConfirm }: Props) => {
  const { close } = useModalContext()
  const [selectedVariantId, setSelectedVariantId] = useState(options[0].value)
  const isVariantOutOfStock =
    options.find((option) => option.value === selectedVariantId)?.quantity === 0

  return (
    <ConfirmModal
      title="Select a variant you want to order"
      text="You’ll be able to add more variants, more products, and adjust quantity in the next step."
      disabled={isVariantOutOfStock}
      additionalContent={
        <div style={{ marginTop: 20 }}>
          <Select
            label="Variant"
            size="medium"
            options={options}
            value={selectedVariantId}
            error={isVariantOutOfStock ? 'This variant is out of stock.' : undefined}
            onValueChange={setSelectedVariantId}
          />
        </div>
      }
      close={close}
      onConfirm={() => onConfirm(selectedVariantId)}
    />
  )
}
